export const timeline = [
  {
    time: '23:40',
    date: '昨天',
    title: '深夜话题升温',
    detail: '一组代拍画面在社交平台流传，相关词条短时间内进入讨论前列，网友开始自发梳理时间线。',
    type: '发酵',
  },
  {
    time: '08:40',
    date: '今天',
    title: '女团活动改期公告',
    detail: '主办方发布简短通知，称原定见面会因档期调整顺延，退改签说明随后补充在公告评论区。',
    type: '官方',
  },
  {
    time: '09:12',
    date: '今天',
    title: '绯闻话题冲上榜首',
    detail: '关于顶流艺人深夜行程的讨论持续攀升，多名娱乐博主整理了“已知信息 / 待确认信息”两栏对照。',
    type: '热点',
  },
  {
    time: '10:05',
    date: '今天',
    title: '综艺同框互动被放大',
    detail: '最新一期节目播出后，两位嘉宾的互动片段被反复剪辑传播，节目组未作额外说明。',
    type: '综艺',
  },
  {
    time: '11:20',
    date: '今天',
    title: '巡演预热页面流出',
    detail: '有网友晒出票务平台尚未开放的巡演页面截图，主办方提醒以官方渠道信息为准。',
    type: '演出',
  },
  {
    time: '13:30',
    date: '今天',
    title: '带货售后争议补充说明',
    detail: '涉事主播团队在直播间口头回应，表示会逐一核对订单并处理售后，随后未再发布书面声明。',
    type: '网红',
  },
  {
    time: '15:15',
    date: '今天',
    title: '搬运争议双方各执一词',
    detail: '原作者补充了更多分镜对比材料，涉事博主维持“独立创作”说法，双方均表示愿意进一步沟通。',
    type: '维权',
  },
  {
    time: '17:00',
    date: '今天',
    title: '本站今日爆料盘点上线',
    detail: '编辑团队对今日热度较高的话题做了集中梳理，标注了信息来源与待核实部分，方便读者快速了解。',
    type: '本站',
  },
];